import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppFlowService } from '../services/app-flow/app-flow.service';
import { Store, select } from "@ngrx/store";
import { take } from 'rxjs/operators';
import { addFlagsToTechSupportAction } from '../../store/actions/tech-support.actions';
import { CopyHelpers } from '../helpers/copy.helpers';

@Injectable({
  providedIn: 'root'
})
export class TechSupportRedirectGuard  {

  activeAppFlow: any;
  techSupport: any;
  orderData: any;
  returnNeeded: boolean = false;
  customerServiceNeeded: boolean = false;
  noReturnNeeded: boolean = false;

  constructor(private router: Router, private appFlowService: AppFlowService, private store: Store<AppState>) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

    this.activeAppFlow = this.appFlowService.getActiveAppFlow();
    const parent = route.parent.routeConfig.path;
    console.log(this.activeAppFlow);

    if (this.activeAppFlow.name.includes("TechSupportFlow")) {

      this.store.pipe(select("techSupport")).pipe(take(1)).subscribe((items) => {
        this.techSupport = items;
      });

      this.store.pipe(select("returnOrder")).subscribe((items) => {
        this.orderData = CopyHelpers.deepCopy(items);
      });

      this.techSupport.items.forEach((item) => {
        if (item.assessmentResult.toLowerCase().trim() === "customer service needed") {
          this.customerServiceNeeded = true;
        }
        if (item.assessmentResult.toLowerCase().trim() === "no return needed") {
          this.noReturnNeeded = true;
        }
        if (item.assessmentResult.toLowerCase().trim() === "return needed") {
          this.returnNeeded = true;
        }
      });

      //Item not eligible for tech support and are returnable
      this.orderData.items.forEach((orderLine) => {
        if (!orderLine.assessmentId && orderLine.returnable) {
          this.returnNeeded = true;
        } else if (
          this.techSupport.items.findIndex(
            (x) => x.assessmentId.toLowerCase().trim() === orderLine.assessmentId.toLowerCase().trim()
          ) === -1 &&
          orderLine.returnable
        ) {
          this.returnNeeded = true;
        }
      });

      const flags = {
        returnNeeded: this.returnNeeded,
        customerServiceNeeded: this.customerServiceNeeded,
        noReturnNeeded: this.noReturnNeeded
      }
      this.store.dispatch(
        addFlagsToTechSupportAction({
          payload: flags,
        })
      );

      if (this.customerServiceNeeded && this.returnNeeded) {
        //return label page with customer service
        return true;
      }
      else if (this.customerServiceNeeded && !this.returnNeeded) {
        //customer service page
        return this.router.parseUrl(`${parent}/labelgenerate`);
      }
      else if (this.noReturnNeeded && !this.customerServiceNeeded && !this.returnNeeded) {
        //thankyou  page
        return this.router.parseUrl(`${parent}/labelgenerate`);
      }
      else {
        //Normal flow return label page
        return true;
      }
    }
    return true;
  }

}
